/**
 * @desc 库存动作重推
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/inventoryActionReboot`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
